/* eslint-disable @typescript-eslint/restrict-template-expressions */
import * as I18n from "./translations/I18n";
export var setDocumentTitle = function (title) {
    var _a;
    var defaultTitle = "".concat((_a = process.env.REACT_APP_TITLE) !== null && _a !== void 0 ? _a : I18n.getText("mary.utils.document.title", "Application by Claude."));
    var newTitle = title ? "".concat(title, " | ").concat(defaultTitle)
        : defaultTitle;
    if (newTitle !== document.title) {
        document.title = newTitle;
    }
};
